"use client";

import React from "react";
import Button from "../SecondaryButton";
import Modal from "./Modal";
import ErrorIcon from "@/assets/error-exclamation.svg";

interface IProps {
  close: () => void;
  isOpen: boolean;
  errorTitle: string;
  errorDescription: React.ReactNode;
  handleTryAgain: () => void;
}

const ErrorModal = ({
  close,
  isOpen,
  errorTitle,
  errorDescription,
  handleTryAgain,
}: IProps) => {
  return (
    <Modal close={close} isOpen={isOpen} className="w-[90%] md:w-[660px]">
      <div className="flex flex-col gap-7 text-white text-center items-center">
        <div className="flex flex-col gap-4 items-center">
          <div className="flex flex-col gap-8 items-center">
            <ErrorIcon className="w-20 h-20" />
            <span className="font-albert-sans text-2xl leading-7 uppercase">
              {errorTitle}
            </span>
          </div>
          <p className="text-base leading-5">{errorDescription}</p>
        </div>
        <div className="flex flex-row gap-4 w-full">
          <Button variant={"dark"} onClick={close}>
            CANCEL
          </Button>
          <Button variant={"light"} onClick={handleTryAgain}>
            TRY AGAIN
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ErrorModal;
